import { loadStripe, type Stripe } from "@stripe/stripe-js";

const stripePublishableKey = String(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? "");

if (!stripePublishableKey) {
  console.warn("VITE_STRIPE_PUBLISHABLE_KEY is not set. Stripe functionality will not work.");
}

// Initialize Stripe
export const stripePromise: Promise<Stripe | null> = loadStripe(stripePublishableKey);

export default stripePromise;
